var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.storehouseIds, function(item) {
              return item.key !== -1
                ? _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "status",
                      class: { active: _vm.origin === item.key },
                      on: {
                        click: function($event) {
                          return _vm.selectOrigin(item.key)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "refForm",
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "QC号" },
                                        model: {
                                          value: _vm.search_type,
                                          callback: function($$v) {
                                            _vm.search_type = $$v
                                          },
                                          expression: "search_type"
                                        }
                                      },
                                      _vm._l(_vm.search_options, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-left": "-15px",
                                      width: "165px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入搜索内容" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.search_value,
                                        callback: function($$v) {
                                          _vm.search_value = $$v
                                        },
                                        expression: "search_value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "是否次品" },
                                        model: {
                                          value: _vm.form.is_cp,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_cp", $$v)
                                          },
                                          expression: "form.is_cp"
                                        }
                                      },
                                      _vm._l(_vm.is_cp, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "是否修复" },
                                        model: {
                                          value: _vm.form.is_repair,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_repair", $$v)
                                          },
                                          expression: "form.is_repair"
                                        }
                                      },
                                      _vm._l(_vm.is_repair, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "一级分类" },
                                        model: {
                                          value: _vm.form.p_catid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "p_catid", $$v)
                                          },
                                          expression: "form.p_catid"
                                        }
                                      },
                                      _vm._l(_vm.conditionData.cp_cat, function(
                                        item
                                      ) {
                                        return item.pid == 0
                                          ? _c("el-option", {
                                              key: item.cp_catid,
                                              attrs: {
                                                label: item.name,
                                                value: item.cp_catid
                                              }
                                            })
                                          : _vm._e()
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "二级分类" },
                                        model: {
                                          value: _vm.form.cp_catid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "cp_catid", $$v)
                                          },
                                          expression: "form.cp_catid"
                                        }
                                      },
                                      _vm._l(_vm.conditionData.cp_cat, function(
                                        item
                                      ) {
                                        return item.pid == _vm.form.p_catid
                                          ? _c("el-option", {
                                              key: item.cp_catid,
                                              attrs: {
                                                label: item.name,
                                                value: item.cp_catid
                                              }
                                            })
                                          : _vm._e()
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否爆版打标" },
                                        model: {
                                          value: _vm.form.is_supply_dbid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_supply_dbid",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_supply_dbid"
                                        }
                                      },
                                      _vm._l(
                                        _vm.is_supply_dbid_option,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "订单号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.order_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "order_id", $$v)
                                        },
                                        expression: "form.order_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "是否微次" },
                                        model: {
                                          value: _vm.form.is_minor_defect,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_minor_defect",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_minor_defect"
                                        }
                                      },
                                      _vm._l(
                                        _vm.is_minor_defect_option,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "质检规则" },
                                        model: {
                                          value: _vm.form.quality_rule,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "quality_rule",
                                              $$v
                                            )
                                          },
                                          expression: "form.quality_rule"
                                        }
                                      },
                                      _vm._l(_vm.qualityRuleOption, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "质检时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "370px" },
                                      attrs: {
                                        type: "datetimerange",
                                        "default-time": [
                                          "06:00:00",
                                          "06:00:00"
                                        ],
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "货号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_no", $$v)
                                        },
                                        expression: "form.goods_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "background-color": "#e1e1e1"
                                        },
                                        on: { click: _vm.resetCondition }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.is_show_search_option
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: { placeholder: "市场" },
                                                model: {
                                                  value: _vm.form.market_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "market_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.market_id"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.market,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.market_id,
                                                    attrs: {
                                                      label: item.market_name,
                                                      value: item.market_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { staticStyle: { width: "150px" } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "档口" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.supply_name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "supply_name",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.supply_name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "买手组"
                                                },
                                                model: {
                                                  value: _vm.form.pg_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pg_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.pg_id"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.picker_group,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.pg_id,
                                                    attrs: {
                                                      label: item.pg_name,
                                                      value: item.pg_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { staticStyle: { width: "150px" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "服装类型"
                                                },
                                                model: {
                                                  value: _vm.form.cat_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "cat_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.cat_id"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.cat,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.cat_id,
                                                    attrs: {
                                                      label: item.cat_name,
                                                      value: item.cat_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "选择入库来源"
                                                },
                                                model: {
                                                  value: _vm.form.stock_source,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "stock_source",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.stock_source"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "",
                                                    label: "全部"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData.stockSource,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.key,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.key
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "是否高级质检"
                                                },
                                                model: {
                                                  value: _vm.form.high_quality,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "high_quality",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.high_quality"
                                                }
                                              },
                                              _vm._l(
                                                _vm.generalOption,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.key,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.key
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("数据列表：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "600",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark",
                              "row-class-name": _vm.tableRowClassName
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "dbid",
                                label: "打标id",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                width: "140",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sku",
                                label: "sku",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "wcg_order_info_price",
                                label: "代采价",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "cat_name_1",
                                label: "一级分类",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "cat_name_2",
                                label: "二级分类",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "cat_name_3",
                                label: "三级分类",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "market_name",
                                label: "市场",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                "show-overflow-tooltip": "",
                                align: "left"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "supply_name",
                                label: "商家",
                                width: "140",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pg_name",
                                label: "买手组",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stockin_time",
                                label: "入库时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_stock_source",
                                label: "入库来源",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dber",
                                label: "点货人员",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sdbr_text",
                                label: "是否爆版打标",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_shipping_stock_out",
                                label: "是否发货出库",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "quality_type",
                                label: "质检类型",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "quality_rule",
                                label: "质检规则",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "order_id",
                                label: "订单号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "desk_no",
                                label: "工作台",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "qc",
                                label: "质检人员",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "质检时间",
                                width: "150",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "high_quality_text",
                                label: "是否高级质检",
                                width: "100",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "quality_checking_is_cp",
                                label: "是否次品",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "p_name",
                                label: "次品一级分类",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "cp_name",
                                label: "次品二级分类",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_minor_defect_text",
                                label: "是否微次",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "quality_checking_is_repair",
                                label: "是否修复",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "xf_qc",
                                label: "修复人员",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "xf_time",
                                label: "修复时间",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: "质检视频",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showVideo(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                查看\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                845124686
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: "备注",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-edit",
                                            size: "mini",
                                            circle: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.seRemark(scope.row)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.remark))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1493061045
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.curPage,
                            background: "",
                            layout: "total, prev, pager, next, jumper",
                            total: _vm.resData.count,
                            "page-size": _vm.form.pagesize
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.curPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.curPage = $event
                            },
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleVideoClose,
            visible: _vm.showQualityVideoList,
            title: "质检视频列表",
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showQualityVideoList = $event
            }
          }
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.handleCopy(_vm.showVideoPath)
                }
              }
            },
            [_vm._v(" 打开文件夹 ")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.qualityVideoList } },
            [
              _c("el-table-column", {
                attrs: { label: "文件", width: "400" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "video-wrap",
                            on: {
                              click: function($event) {
                                return _vm.handleCopy(
                                  _vm.showVideoPath + "\\" + scope.row.video_key
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-video-camera-solid"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "video-file-name" }, [
                              _vm._v(_vm._s(scope.row.video_key))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "起始时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "video-wrap",
                            on: {
                              click: function($event) {
                                return _vm.handleCopy(
                                  _vm.showVideoPath + "\\" + scope.row.video_key
                                )
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(scope.row.start_point))])]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleVideoClose }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15d433b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d433b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quality/QualityList.vue
// module id = null
// module chunks = 